export default "__VITE_ASSET__XIIssGLp__"